/**
 * Renders the mini news hero on the home page, containing mini news item components
 * WARNING: Uses temporary dummy data
 */
import React from "react";
import { useState, useEffect } from "react";
import MiniNewsContainer from "./MiniNewsContainer";
import NewsContainer from "./NewsContainer";
import Loading from "../core/Loading";

const NewsHero = () => {
  const [data, setData] = useState(undefined);

  // Fetch player data from API
  useEffect(() => {
    setData(undefined);

    fetch(`${process.env.REACT_APP_BUIHA_API_URL}/news/?offset=0&count=5&preview=true`)
      .then((response) => response.json())
      .then((json) => {
        let data = json;

        setData(data);
      })
      .catch((error) => console.error(error));
  }, []);

  return data ? (
    <>
        <NewsContainer data={data.slice(0, 2)} />
        <MiniNewsContainer data={data.slice(1, 5)} />
    </>
    
  ) : (
    <Loading height={392+116} />
  )
};
export default NewsHero;
